// src/pages/Welcome/ListingsGrid.jsx
import React from 'react';
import { welcomeStyles } from './styles';
import ListingCard from '../../components/ListingCard';

const ListingsGrid = ({ listings }) => {
  return (
    <div style={welcomeStyles.listingsGrid}>
      {listings.map((listing) => (
        <ListingCard key={listing.id} listing={{ ...listing }} />
      ))}
    </div>
  );
};

export default ListingsGrid;